export const REPEAT_INTERVAL = 1000;

const INITIAL_REPEAT_INTERVAL_COEF = 1;
const MAX_REPEAT_INTERVAL_COEF = 10;

type CallbackType = () => Promise<boolean>; // true if ok

export default class Cycler {
  private timeoutKey: any = null;
  private repeatIntervalCoef: number = INITIAL_REPEAT_INTERVAL_COEF;
  private interval: number = REPEAT_INTERVAL;
  private callback: CallbackType | null; // returns ok

  init(callback: CallbackType, interval: number = REPEAT_INTERVAL): void {
    this.stop();

    this.callback = callback;
    this.interval = interval;

    setTimeout(this.call, 0);
  }

  stop(): void {
    if (this.timeoutKey) {
      clearTimeout(this.timeoutKey);
      this.timeoutKey = null;
    }

    this.callback = null;
    this.interval = REPEAT_INTERVAL;
    this.resetRepeatIntervalCoef();
  }

  private call = async (): Promise<void> => {
    if (!this.callback) {
      return;
    }

    const ok = await this.callback();

    if (ok) {
      this.resetRepeatIntervalCoef();
    } else {
      this.incRepeatIntervalCoef();
    }

    this.timeoutKey = setTimeout(
      this.call,
      this.interval * this.repeatIntervalCoef
    );
  };

  private resetRepeatIntervalCoef(): void {
    this.repeatIntervalCoef = INITIAL_REPEAT_INTERVAL_COEF;
  }

  private incRepeatIntervalCoef(): void {
    this.repeatIntervalCoef = Math.min(
      this.repeatIntervalCoef + 1,
      MAX_REPEAT_INTERVAL_COEF
    );
  }
}
